// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from './store/index'
import axios from 'axios'
import Vant from 'vant'
import wx from 'weixin-js-sdk'
import 'vant/lib/index.css'
import 'lib-flexible'
import 'font-awesome/css/font-awesome.min.css'

import ba from 'vue-ba'
import {keywordHighlight} from './filters/commonFilters'
import { settingCache, clearCache, getterCache } from './utils/common'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(Vant)
Vue.use(ba, {siteId: '4e3aa00e4254ac7a9175eec39c5f203e'})

// 全局方法，关键字高亮
Vue.prototype.keywordHighlight = keywordHighlight
Vue.prototype.$wx = wx
// 防止重复 注入 生命全局函数 .
Vue.prototype.settingCache = settingCache
Vue.prototype.clearCache = clearCache
Vue.prototype.getterCache = getterCache

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js